export default "अ\nआ\nइ\nई\nउ\nऊ\nऋ\nए\nऐ\nओ\nऔ\nक\nख\nग\nघ\nच\nछ\nज\nझ\nट\nठ\nड\nढ\nण\nत\nथ\nद\nध\nन\nप\nफ\nब\nभ\nम\nय\nर\nल\nव\nश\nष\nस\nह"